(function ($) {
  "use strict";

  $(document).ready(function () {
    AOS.init({
      // Global settings:
      disable: "mobile", // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
      initClassName: "aos-init", // class applied after initialization
      animatedClassName: "aos-animate", // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    const $owlCarousel = $(".agency-slider-active").owlCarousel({
      items: 1,
      dots: true,
      loop: true,
      autoplayTimeout: 9000,
      autoplay: true,
    });

    $(".owl-carousel").on("initialized.owl.carousel", () => {
      setTimeout(() => {
        $(".owl-item.active .animated-text").addClass("is-transitioned");
      }, 200);
    });

    $owlCarousel.on("changed.owl.carousel", (e) => {
      $(".animated-text").removeClass("is-transitioned");

      const $currentOwlItem = $(".owl-item").eq(e.item.index);
      $currentOwlItem.find(".animated-text").addClass("is-transitioned");

      const $target = $currentOwlItem.find(".hero-contents");
    });

    $(".b-opinions__carousel").owlCarousel({
      loop: true,
      dots: true,
      autoplay: false,
      // autoWidth: true,
      center: false,
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
          // margin: 10,
        },
        // breakpoint from 768 up
        768: {
          items: 1,
          margin: 20,
        },
        // breakpoint from 992 up
        992: {
          items: 3,
          margin: 20,
        },

        1400: {
          items: 3,
          margin: 20,
        },
      },
    });

    $(".owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      autoplayTimeout: 8000,
      autoplay: true,
      center: true,
    });

    /* =============================================
            # Magnific popup init
         ===============================================*/

    $(".b-gallery-items__item").magnificPopup({
      delegate: "a",
      type: "image",
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: "mfp-with-zoom mfp-img-mobile",
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        tCounter: "%curr% z %total%",
      },
      zoom: {
        enabled: true,
        duration: 300,
        opener: function (element) {
          return element.find("img");
        },
      },
    });

    /*==========================
           Scroll To Up Init
        ============================*/
    $.scrollUp({
      scrollName: "scrollUp-old", // Element ID
      topDistance: "1110", // Distance from top before showing element (px)
      topSpeed: 2000, // Speed back to top (ms)
      animation: "slide", // Fade, slide, none
      animationInSpeed: 300, // Animation in speed (ms)
      animationOutSpeed: 300, // Animation out speed (ms)
      scrollText: '<i class="fas fa-angle-up"></i>', // Text for element
      activeOverlay: false, // Set CSS color to display scrollUp active point, e.g '#00FFFF'
    });

    $("#hamburger-icon").on("click", function () {
      $(".off-canvas").addClass("is-open");
    });

    $("#close-icon").on("click", function () {
      $(".off-canvas").removeClass("is-open");
    });

    $("#offCanvas .menu-item-has-children > .nav-link").on(
      "click",
      function (e) {
        e.preventDefault();

        const $parent = $(this).parent();
        const $child = $parent.children(".nav-link");
        const $dropdown = $parent.children(".dropdown-menu");

        if ($dropdown.length) {
          if ($dropdown.is(":visible")) {
            $dropdown.slideUp(300);
            $parent.removeClass("is-open");
            $child.removeClass("active");
          } else {
            $dropdown.slideDown(300);
            $parent.addClass("is-open");
            $child.addClass("active");
          }
        }
      }
    );

    /*==========================
           FAQ Accordion Init
        ============================*/
    $("[data-faq-toggle]").on("click", function (e) {
      const $item = $(this).closest("[data-faq-item]");
      const $isActive = $item.hasClass("is-active");

      if ($isActive) {
        $item.removeClass("is-active");
        $(this).attr("aria-expanded", "false");
      } else {
        $("[data-faq-item]").removeClass("is-active");
        $("[data-faq-toggle]").attr("aria-expanded", "false");
        $item.addClass("is-active");
        $(this).attr("aria-expanded", "true");
      }
    });
  }); // end document ready function
})(jQuery); // End jQuery
